import styled, { css } from 'styled-components';

import { TableContainer } from 'components/DefaultTable/styles';

import colors from 'themes/Main';

const { gray01, gray03 } = colors;

export const FieldDescription = styled.small`
  color: ${gray01};
  display: block;
  font-size: 14px;
  margin-top: 8px;

  span {
    font-weight: 700;
    margin-left: 4px;
  }
`;

export const Callback = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

export const CallbackText = styled.p`
  color: ${gray03};
  font-size: 14px;
  font-weight: 600;
  margin-top: 24px;
  max-width: 250px;
  text-align: center;
`;

export const Table = styled(TableContainer)`
  margin-top: 32px;

  ${({ isFunction }) =>
    isFunction &&
    css`
      tr td:nth-of-type(3) {
        padding-right: 32px;
        width: 25%;
      }

      tr td:first-child {
        padding-right: 32px;
        width: 20%;
      }
    `}

  .table-responsive {
    padding: 32px 40px;
  }
`;

export const Button = styled.button.attrs({
  type: 'button',
})`
  cursor: pointer;
  background-color: transparent;
  border: 0;
  transition: opacity 0.3s ease-in-out;

  &:hover {
    opacity: 0.4;
  }

  & + button {
    margin-left: 16px;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
`;
